import React from 'react'
import { PongSpinner } from 'react-spinners-kit'
import { useStyles } from './Styles'

export const FormLoader = ({ props, loading }) => {
  let classes = useStyles()
  return (
    <div className={classes.formLoaderWrapper}>
      <PongSpinner
        size={80}
        color='#427cac'
        loading={loading}
      />
    </div>
  )
}
